var YouLi = YouLi ? YouLi : {};
YouLi.Common = YouLi.Common ? YouLi.Common : {};

(function (YouLi) {
    (function (Common) {

        YouLi.Common.PaymentGateway = {
            Stripe: 0,
            Square: 1,
            CyberSource: 2,
            AuthorizeNet: 3,
            PayPal: 4,
        };

        function errorHandler(jqXHR, textStatus, errorThrown, errorCallback) {
            // always clean up on fail
            YouLi.Common.UI.FormatClientSideErrors("")

            if (errorCallback != null && typeof errorCallback === 'function') {
                errorCallback(jqXHR, textStatus, errorThrown);
                return true;
            }

            // Implement Modal general error handling
            YouLi.Common.UI.ShowStandardDialog("An error has occurred.");
        }

        function successHandler(data, textStatus, jqXHR) {

        }

        YouLi.Common.SendPaymentReceipt = function (tripId, inviteeId, isPlannerTriggered) {

            var data = {
                tripid: tripId,
                inviteeid: inviteeId,
                isPlannerTriggered: isPlannerTriggered ? isPlannerTriggered : false,
            };

            YouLi.Common.Post({
                url: "/trip/SendInviteeReceipt",
                params: data,
            }).then(function (response) {
                if (response != undefined && response.success == false) {
                    YouLi.Common.UI.ShowStandardDialog("An error occurred when sending email.");
                }
                else {
                    let title = response.successMessageTitle;
                    let message = response.message;

                    YouLi.Common.UI.ShowStandardDialog(message, title, "Okay", "success");
                }
            });
        };

        YouLi.Common.OpenSupportTicket = function (userMessage, debugMessage, subject) {

            YouLi.Common.Post({
                url: '/trip/opensupportticket/',
                params: {
                    userMessage: userMessage,
                    debugMessage: debugMessage,
                    subject: subject
                },
                suppressLoading: true,
            });

            // note: we don't do anything special on success or fail
        }

        YouLi.Common.GetUrlParam = function (key) {
            const url = new URL(window.location.href);
            return url.searchParams.get(key);
        };

        YouLi.Common.UpdateUrlParam = function (key, value) {
            const url = new URL(window.location);
            value = encodeURIComponent(value);
            url.searchParams.set(key, value);
            window.history.pushState({}, '', window.unescape(url));
        }

        YouLi.Common.UpdateUrlParams = function (key, values) {
            let urlParams = new URLSearchParams(window.location.search);
            let existingValues = urlParams.getAll(key);

            existingValues.forEach(function (value) {
                urlParams.delete(key);
            });

            values.forEach(function (value) {
                urlParams.append(key, value);
            });

            window.history.replaceState({}, '', '?' + urlParams.toString());
        }

        YouLi.Common.ClearUrlParams = function (key) {
            const url = new URL(window.location.href);

            url.searchParams.delete(key);

            // If no params left, remove the "?"
            if (!url.searchParams.toString()) {
                url.search = "";
            }

            window.history.replaceState({}, document.title, url.toString());
        };

        YouLi.Common.GetGAData = function (eventName) {
            var data = {
                event: eventName,
                planner_has_ecommerce: $("#ECommerceDataLayerEnabled").val()

            };
            var items = [
                {
                    item_id: $("#GA_Alias").val(),
                    item_name: $("#GA_TripName").val(),
                    item_variant: $("#GA_PackageName").val(),
                    affiliation: $("#GA_BookingAffiliateCode").val(),
                    currency: $("#GA_CurrencyCode").val(),
                    item_brand: $("#GA_BusinessName").val(),
                    price: $("#GA_CostPerPerson").val(),
                    quantity: $("#GA_Quantity").val(),
                    location_id: $("#GA_PrimaryLocation").val(),
                }
            ];

            if (eventName == "view_item") {
                data.ecommerce = {
                    currency: $("#GA_CurrencyCode").val(),
                    value: $("#GA_CostPrepayTotalOutstanding").val(),
                    items: items
                }
            }

            if (eventName == "select_promotion") {
                data.ecommerce = {
                    promotion_id: $("#SelectedCouponCode").val(),
                    promotion_name: $("#SelectedCouponCode").val(),
                    items: items
                }
            }

            if (eventName == "generate_lead" || eventName == "add_to_cart" || eventName == "remove_from_cart" || eventName == "view_cart") {
                data.ecommerce = {
                    currency: $("#GA_CurrencyCode").val(),
                    value: $("#GA_CostPrepayTotalOutstanding").val(),
                    items: items
                }
            }

            if (eventName == "begin_checkout") {
                data.ecommerce = {
                    currency: $("#GA_CurrencyCode").val(),
                    value: $("#GA_CostPrepayTotalOutstanding").val(),
                    coupon: $("#SelectedCouponCode").val(),
                    tax: $("#GA_Tax").val(),
                    items: items
                }
            }

            if (eventName == "purchase") {
                data.ecommerce = {
                    transaction_id: $("#GA_TransactionId").val(),
                    currency: $("#GA_CurrencyCode").val(),
                    value: $("#GA_CostPrepayTotalOutstanding").val(),
                    coupon: $("#SelectedCouponCode").val(),
                    items: items
                }
            }

            var firstItem = data.ecommerce.items[0];
            if ($("#GA_Tag0").length) {
                firstItem.item_category = $("#GA_Tag0").val();
            }
            if ($("#GA_Tag1").length) {
                firstItem.item_category2 = $("#GA_Tag1").val();
            }
            if ($("#GA_Tag2").length) {
                firstItem.item_category3 = $("#GA_Tag2").val();
            }
            if ($("#GA_Tag3").length) {
                firstItem.item_category4 = $("#GA_Tag3").val();
            }
            if ($("#GA_Tag4").length) {
                firstItem.item_category5 = $("#GA_Tag4").val();
            }

            return data;
        }

        YouLi.Common.Get = function (options) {
            options.method = "GET";
            return fetchRequest(options);
        }

        YouLi.Common.Post = function (options) {
            options.method = 'POST';
            return fetchRequest(options);
        }

        YouLi.Common.Put = function (options) {
            options.method = "PUT";
            return fetchRequest(options);
        }

        YouLi.Common.Delete = function (options) {
            options.method = "DELETE";
            return fetchRequest(options);
        }

        YouLi.Common.HandleFormValidation = function (form, errors) {
            const $form = $(form);

            $.each(errors, function (key, val) {
                let container = $form.find('span[data-valmsg-for="' + key + '"]');
                container.removeClass("field-validation-valid").addClass("field-validation-error");
                const last = val[val.length - 1];
                // Handle both PascalCase (Newtonsoft/dictionary keys) and camelCase (STJ) serialization
                container.html(last.ErrorMessage || last.errorMessage);
                $(".field-validation-error").closest(".form-group").addClass("has-error").removeClass("has-success");
            });

            let summaryContainer = $form.find('div[data-valmsg-summary=true]'),
                list = summaryContainer.find("ul");

            if (list && list.length && errors) {
                list.empty();
                summaryContainer.addClass("validation-summary-errors").removeClass("validation-summary-valid");

                $.each(errors, function () {
                    const last = this[this.length - 1];
                    $("<li />").html(last.ErrorMessage || last.errorMessage).appendTo(list);
                });
            }
        }

        YouLi.Common.ContainsCreditCardInfo = function (input) {
            if (!input || input.trim() === "") {
                return "";
            }

            const amexCondition = /3[47]\d{2}[- ]\d{6}[- ]\d{5}/;
            const masterVisaCondition = /\d{4}([\s-]\d{4}){3,4}/;
            const dinerClubCondition = /3(?:6|8|9\d)\d{2}[- ]\d{6}[- ]\d{4}/;

            if (amexCondition.test(input) || masterVisaCondition.test(input) || dinerClubCondition.test(input)) {
                return "It looks like your note contains credit card information.  Please remove this and try again.";
            }

            return "";
        }

        // Returns a promise, so we can handle this in the caller as needed.
        function fetchRequest(options) {
            const {url, fetchOptions, settings} = buildAjaxOptions(options);

            if (!settings.suppressLoading) {
                YouLi.Common.UI.ShowLoading();
            }

            return fetch(url, fetchOptions)
                .then(function (response) {
                    if (!response.ok) {
                        // 1. Read the full HTML error page as text
                        return response.text().then(htmlError => {
                            return Promise.reject({
                                responseText: htmlError,
                                status: response.status,
                                statusText: response.statusText
                            });
                        });
                    }

                    const contentType = response.headers.get("content-type");

                    if (response.redirected && response.url.toLowerCase().includes("/login")) {
                        location.href = YouLi.Common.Utils.AddorUpdateParameterToURL(response.url, "ReturnUrl", location.href.replace(location.origin, ""));
                        return new Promise(function () {
                        });
                    }

                    if (contentType && contentType.indexOf("application/json") !== -1) {
                        return response.json();
                    } else {
                        return response.text();
                    }
                })
                .finally(function () {
                    // Equivalent to .always()
                    if (!settings.suppressLoading) {
                        YouLi.Common.UI.HideLoading();
                    }

                    // do this always
                    if (settings.$form.length > 0) {
                        const submitBtn = $('form').find("button[type='submit']");
                        YouLi.Common.UI.HideButtonLoading(submitBtn);
                    }

                    if (settings.finallyCallback) {
                        settings.finallyCallback();
                    }
                })
                .catch(function (error) {
                    errorHandler(error, error.status, error.statusText, settings.errorCallback);
                    return new Promise(function () {
                    });
                });
        }

        function buildAjaxOptions(options) {
            if (typeof options !== 'object' || options === null) {
                throw new Error('The argument must be an object.');
            }

            const defaults = {
                url: null,
                method: 'GET',
                params: null,
                contentType: "application/json; charset=utf-8",
                suppressLoading: false,
                $form: $(),
                errorCallback: null,
                // Good to have in situation where we need to trigger cleanup for both success and failure
                finallyCallback: null,
                cache: null,
            };

            const settings = $.extend({}, defaults, options);

            let fetchOptions = {
                method: settings.method,
                headers: {}
            };

            if (settings.contentType) {
                fetchOptions.headers['Content-Type'] = settings.contentType;
            }

            fetchOptions.headers['X-Requested-With'] = 'XMLHttpRequest';

            if (settings.cache) {
                fetchOptions.cache = settings.cache;
            }

            // Anti-forgery validation is a cookie + hidden field pair. The server validates
            // both match the same session — so if multiple tokens exist on the page (e.g.
            // from multiple partial views), any one of them is valid; .first() is safe.
            //
            // The token is always attached regardless of which action is being called.
            // Actions without [ValidateHeaderAntiForgeryToken] simply ignore the header,
            // so sending it unnecessarily is harmless.
            if (['POST', 'PUT', 'DELETE'].includes(settings.method)) {
                const token = $('input[name="__RequestVerificationToken"]').first().val();

                if (token)
                    fetchOptions.headers['__RequestVerificationToken'] = token;
            }

            // In fetch, GET/HEAD requests cannot have a body
            if (settings.params && settings.method !== 'GET' && settings.method !== 'HEAD') {
                fetchOptions.body = (settings.contentType && settings.contentType.indexOf('application/json') !== -1)
                    ? JSON.stringify(settings.params)
                    : settings.params;
            } else {
                // This is for GET/HEAD requests that have params
                settings.url = buildQueryParam(settings.url, settings.params);
            }

            return {
                url: settings.url,
                fetchOptions: fetchOptions,
                settings: settings
            };
        }

        function buildQueryParam(url, params) {
            if (!params) return url;

            let queryParams = [];

            $.each(params, function (key, val) {
                if (!Object.prototype.hasOwnProperty.call(params, key)) {
                    return;
                }

                if (Array.isArray(val)) {
                    $.each(val, function (_, item) {
                        queryParams.push(encodeURIComponent(key) + '=' + encodeURIComponent(item));
                    });
                } else if (val !== undefined && val !== null) {
                    queryParams.push(encodeURIComponent(key) + '=' + encodeURIComponent(val));
                }
            });

            if (queryParams.length === 0) {
                return url;
            }

            return url + (url.indexOf('?') === -1 ? '?' : '&') + queryParams.join('&');
        }


    }(YouLi.Common ? YouLi.Common : {}));
}(YouLi ? YouLi : {})); 